export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return `<a href="/accreditations/applications/${item.id}" target="_blank">${item.record || ''}</a>`;
                    }
                },
                {
                    title: 'Tipo de Acreditacion',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return item.accreditation_type.name;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'accreditation_applications',
                    modifier: (item) => {
                        return item.organization.name;
                    }
                },
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (item) => {
                        return item == 'E' ? 'Evaluacion' : 'Testificacion';
                    }
                },
                {
                    title: 'Codigo',
                    type: 'text',
                    key: 'code',
                },
                // {
                //     title: 'Fecha de Registro',
                //     type: 'custom-html',
                //     key: 'date_start',
                //     modifier: (item) => {
                //         return item;
                //     }
                // },
                {
                    title: 'Planificación desde',
                    type: 'custom-html',
                    key: 'date_start',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Planificación hasta',
                    type: 'custom-html',
                    key: 'date_end',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Agrupado',
                    type: 'custom-html',
                    key: 'key_combo',
                    modifier: (item) => {
                        if(item){
                            return `<span class="badge badge-sm badge-pill badge-primary">Por ${item}</span>`;
                        }else{
                            return 'N/A';
                        }
                    }
                },
                {
                    title: 'Días Disponibles',
                    type: 'custom-html',
                    key: 'eval_test_time',
                    modifier: (value) => {
                        let tmp;
                        if (value) {
                            if (value.remaining_days > 1) {
                                tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
                            }
                            if (value.remaining_days == 1) {
                                tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
                            }
                            if (value.remaining_days == 0) {
                                tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
                            }
                        }
                        return tmp;
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}